module.exports = __webpack_public_path__ + "static/media/keycompounding_logo.c82ed051.png";